import React from 'react';
import { Phone, ArrowRight, ShieldCheck, Star, MapPin, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 lg:py-28 bg-navy text-white relative overflow-hidden" data-id="element-61">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-navy-800 via-navy to-navy z-0" data-id="element-62"></div>

      {/* Lightning Bolt SVG */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-5xl opacity-[0.05] animate-lightning-pulse pointer-events-none z-0" data-id="element-63">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full text-accent" data-id="element-64">
          <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5" strokeLinejoin="round" data-id="element-65" />
        </svg>
      </div>

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-1/2 bg-accent/20 blur-[120px] rounded-full z-0 pointer-events-none" data-id="element-66"></div>

      <div className="max-w-5xl mx-auto px-4 text-center relative z-10" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        type: 'spring'
      }} data-id="element-68">
          <div className="inline-flex items-center gap-2 bg-red-600/20 border border-red-500/30 text-red-100 rounded-full px-5 py-2 text-sm font-bold backdrop-blur-md mb-8 shadow-lg" data-id="element-69">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-70"></span>
            Same-day service available, call now
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white mb-6 tracking-tighter leading-[1.1]" data-id="element-71">
            Let's get your electrical
            <br data-id="element-72" />
            sorted today.
          </h2>
          <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-73">
            One call. Upfront pricing. A licensed electrician who delivers
            quality work, every time.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-10" data-id="element-74">
            {/* The Completely Electrical Guarantee */}
            <div className="inline-flex items-center gap-3 bg-white/10 border border-white/20 rounded-xl px-6 py-3 backdrop-blur-sm" data-id="element-75">
              <ShieldCheck className="w-6 h-6 text-accent" data-id="element-76" />
              <div className="text-left" data-id="element-77">
                <span className="text-white font-extrabold text-sm block" data-id="element-78">
                  The Completely Electrical Guarantee
                </span>
                <span className="text-gray-300 text-xs" data-id="element-79">
                  Quality workmanship, every time. No shortcuts.
                </span>
              </div>
            </div>

            {/* 441+ Reviews */}
            <div className="inline-flex items-center gap-3 bg-emerald-500/10 border border-emerald-500/20 rounded-xl px-6 py-3 backdrop-blur-sm" data-id="element-80">
              <Star className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-81" />
              <div className="text-left" data-id="element-82">
                <span className="text-white font-extrabold text-sm block" data-id="element-83">
                  441+ Five-Star Reviews
                </span>
                <span className="text-gray-300 text-xs" data-id="element-84">
                  Trusted by Perth's south side homeowners
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-5 mb-12" data-id="element-85">
            <a href="tel:0418381988" className="group w-full sm:w-auto bg-accent hover:bg-accent-600 text-white px-10 py-5 rounded-xl font-extrabold text-xl flex items-center justify-center gap-3 transition-all shadow-[0_0_30px_rgba(62,164,78,0.4)] hover:shadow-[0_0_40px_rgba(62,164,78,0.6)] hover:-translate-y-1" data-id="element-86">
              <div className="bg-white/20 p-2 rounded-full group-hover:bg-white/30 transition-colors" data-id="element-87">
                <Phone className="w-6 h-6" data-id="element-88" />
              </div>
              Call 0418 381 988
            </a>
            <a href="#quote" className="group w-full sm:w-auto bg-white/10 hover:bg-white/20 border border-white/20 text-white px-10 py-5 rounded-xl font-extrabold text-xl flex items-center justify-center gap-3 transition-all backdrop-blur-sm hover:-translate-y-1" data-id="element-89">
              Get a Free Quote
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-90" />
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm font-bold text-gray-200" data-id="element-91">
            <span className="flex items-center gap-2" data-id="element-92">
              <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-93" /> 5.0
              Google Rating
            </span>
            <span className="hidden md:block text-white/20" data-id="element-94">•</span>
            <span className="flex items-center gap-2" data-id="element-95">
              <ShieldCheck className="w-5 h-5 text-emerald-400" data-id="element-96" /> Fully
              Licensed & Insured
            </span>
            <span className="hidden md:block text-white/20" data-id="element-97">•</span>
            <span className="flex items-center gap-2" data-id="element-98">
              <CheckCircle2 className="w-5 h-5 text-accent" data-id="element-99" /> 441+ Reviews
            </span>
            <span className="hidden md:block text-white/20" data-id="element-100">•</span>
            <span className="flex items-center gap-2" data-id="element-101">
              <MapPin className="w-5 h-5 text-accent" data-id="element-102" /> Huntingdale Based
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}